import React from "react";
import "../styles.scss";
import { Text, H1 } from "@amzn/stencil-react-components/text";
import { Row } from "@amzn/stencil-react-components/layout";
import useArb from "../../../hooks/use-arb";
import { StatusContainer } from "./status-container";
import { getI9Status, getTaskScreeningResultStatus, ScreenResult } from "../../../utility/screening-results-helper";

import {
  ScreeningResultsControlledInput,
  getScreeningResultStatusFunc,
  i9GetScreeningResultStatusFunc,
} from "../../screening-results/card-controlled";
import { Button, ButtonSize, ButtonIconPosition } from "@amzn/stencil-react-components/button";
import { ScreeningResultCompletedHeader } from "./screening-result-complete";
import { ScreeningResultErrorHeader } from "./screening-result-error";
import { ScreeningProcessHeader } from "./screening-result-process";
import { ProgressArc } from "@amzn/stencil-react-components/spinner";
import { isAirJob } from "../../screening-results/card-uncontrolled";
import { LAUNCHED_COUNTRY, RIGHT_TO_WORK_TASK_DEFINITION_ID } from "../../../config/appConfigConstants";
import { useParams } from "react-router";
import { getRightToWorkOrI9TaskType } from "../../../utility/app-config-helper";
import { getRegionFromCookie } from "../../../utility/locale-helper";

function isStatusCompleted(status: string) {
  return status === ScreenResult.Complete || status === ScreenResult.Undefined;
}
export const ScreeningResultsProgressControlled = ({ property, jobDetails }: ScreeningResultsControlledInput) => {
  const bundle = useArb("HVHChecklistPantherResource");

  const { applicationId } = useParams<{
    applicationId: string;
  }>();

  const country = getRegionFromCookie() as LAUNCHED_COUNTRY;
  const isGenericRightToWorkTask = getRightToWorkOrI9TaskType(RIGHT_TO_WORK_TASK_DEFINITION_ID, applicationId);

  const RtwOrI9Status = isGenericRightToWorkTask
    ? getScreeningResultStatusFunc(property.i9Response, getTaskScreeningResultStatus)
    : i9GetScreeningResultStatusFunc(property.i9Response, getI9Status);

  const bgcStatus = getScreeningResultStatusFunc(property.bgcResponse, getTaskScreeningResultStatus);

  const dtStatus = getScreeningResultStatusFunc(property.dtResponse, getTaskScreeningResultStatus);

  const airBgcStatus = getScreeningResultStatusFunc(property.airBgcResponse, getTaskScreeningResultStatus);

  if (
    RtwOrI9Status === ScreenResult.Error ||
    bgcStatus === ScreenResult.Error ||
    dtStatus === ScreenResult.Error ||
    airBgcStatus === ScreenResult.Error
  ) {
    return <ScreeningResultErrorHeader />;
  }

  if (
    RtwOrI9Status === ScreenResult.Pending ||
    bgcStatus === ScreenResult.Pending ||
    dtStatus === ScreenResult.Pending ||
    airBgcStatus === ScreenResult.Pending
  ) {
    return <ScreeningProcessHeader />;
  }

  if (
    isStatusCompleted(RtwOrI9Status) &&
    isStatusCompleted(bgcStatus) &&
    isStatusCompleted(dtStatus) &&
    isStatusCompleted(airBgcStatus)
  ) {
    return <ScreeningResultCompletedHeader />;
  }

  const UKResults: string[] = [RtwOrI9Status, bgcStatus];
  const USResults: string[] = [RtwOrI9Status, bgcStatus, dtStatus];

  if (isAirJob(jobDetails?.businessLine)) {
    USResults.push(airBgcStatus);
  }

  const results = country === LAUNCHED_COUNTRY.US ? USResults : UKResults;
  const count = results.filter((result) => result === ScreenResult.Complete).length.toString();
  const totalCount = results.length.toString();

  const formattedProcessingScreenMsg = bundle.getMessage("Checklist-AppointmentCard-Screen-Result");
  const progressBtnText = bundle.getMessage("Checklist-AppointmentCard-ButtonText6");
  const totalTestCountText = bundle.getMessage("Checklist-AppointmentCard-Screen-Test-Count");

  return (
    <StatusContainer
      largeViewPortImage={require("./sandwatch.svg").default}
      smallViewPortImage={require("./sandwatch.svg").default}
    >
      <H1 fontSize={"T400"} fontWeight={"regular"} textAlign="center" id="main-content">
        {formattedProcessingScreenMsg}
      </H1>

      <Row gridGap={"1rem"}>
        <Text fontSize={"T200"}>{count + "/" + totalCount + " " + totalTestCountText}</Text>
      </Row>
      <Row>
        <Button
          size={ButtonSize.Small}
          icon={<ProgressArc />}
          iconPosition={ButtonIconPosition.Leading}
          onClick={() => document.getElementById("screeningresult")?.scrollIntoView()}
        >
          {progressBtnText}
        </Button>
      </Row>
    </StatusContainer>
  );
};
